<template>
  <v-dialog fullscreen persistent v-model="dialog">
    <template v-slot:activator="{ on }">
      <v-btn small text @click="activatorHandler" v-if="adder">
        <v-icon small left>fa-carrot</v-icon>
        Produit
      </v-btn>
      <v-btn small text v-on="on" v-else>
        <v-icon small left>
          fa-edit
        </v-icon>
        Modifier le produit
      </v-btn>
    </template>
    <v-card>
      <v-card-actions class="pa-0">
        <v-container class="pb-0">
          <v-row align="center" justify="space-between" no-gutters>
            <v-btn text @click="dialog = false">
              <v-icon left>fa-times</v-icon>
              Annuler
            </v-btn>
            <v-row align="center" justify="end" no-gutters>
              <span
                class="overline"
                v-for="(name, index) in openEditors"
                :key="`${name}${index}`"
              >
                {{ name }}
                <v-icon
                  x-small
                  class="mx-1"
                  v-show="openEditors.length - 1 !== index"
                  >fa-chevron-right</v-icon
                >
              </span>
            </v-row>
          </v-row>
        </v-container>
      </v-card-actions>
      <v-card-text class="pa-0">
        <RecipeProductEditor
          dialog
          ref="editor"
          :id="id"
          @save="saveHandler"
        ></RecipeProductEditor>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ProductDialogEditor",
  props: {
    id: {
      required: true
    },
    adder: {
      type: Boolean,
      default: false
    },
    openEditors: {
      default: () => []
    },
    recipeId: {
      required: true
    }
  },
  computed: {
    ...mapGetters(["getProducts", "getRecipes"])
  },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    openHandler() {
      this.$refs.editor.getData();
    },
    saveHandler() {
      this.dialog = false;
    },
    activatorHandler() {
      setTimeout(() => (this.dialog = true), 200);
    },
    getName(id) {
      const r = this.getRecipes.find(x => x.id === id);
      if (r) return r.nom;
    },
    getProductName(id) {
      const p = this.getProducts.find(x => x.id === id);
      if (p) return p.nom;
    }
  },
  watch: {
    dialog(v) {
      if (v === true) {
        if (this.openEditors.length === 0) {
          this.openEditors.push(this.getName(this.recipeId));
        }
        this.openEditors.push(this.getProductName(this.id));
        setTimeout(() => this.openHandler(), 200);
      } else {
        this.openEditors.pop();
      }
    }
  }
};
</script>

<style></style>
